import React, { FC } from 'react'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import { LocaleCurrency } from 'components/FormatPrice'
import ArtworkInfo from './Artwork'
import ArtistInfo from './Artist'
import { getArtworkProps, getArtistProps } from './helpers'
import { Item } from './styles'
import classNames from 'classnames'

type Props = Record<string, any>

const Component: FC<Props> = (props) => {
  const {
    shouldOpenNewDesktopPdpTab,
    hasLimitedEditions,
    hasOpenEditions,
    minPrintPrice,
    originalStatus,
    listPrice,
  } = props
  const artworkProps = getArtworkProps(props)
  const artistProps = getArtistProps(props)
  return (
    <Item data-type='print'>
      <div data-style='row' data-type='info'>
        <ArtworkInfo {...artworkProps} shouldOpenNewDesktopPdpTab={shouldOpenNewDesktopPdpTab} />
      </div>

      <div data-style='row' data-type='info'>
        <ArtistInfo {...artistProps} />

        <div data-style='column' data-type='prices'>
          {hasOpenEditions && (
            <h6
              className={classNames('defaultTypographyH6', 'defaultTextTruncate')}
              data-type='main'
            >
              Prints from <LocaleCurrency price={convertFromCentsToDollars(minPrintPrice)} />
            </h6>
          )}
          {hasLimitedEditions && (
            <h6
              className={classNames('defaultTypographyH6', 'defaultTextTruncate')}
              data-type='main'
            >
              Prints from <LocaleCurrency price={convertFromCentsToDollars(minPrintPrice)} />
            </h6>
          )}

          {originalStatus !== 'unavail' && (
            <p
              className={classNames('defaultTypographyXSmall', 'defaultTextTruncate')}
              data-type='sub'
            >
              Original <LocaleCurrency price={convertFromCentsToDollars(listPrice)} />
            </p>
          )}
        </div>
      </div>
    </Item>
  )
}

export default Component
